import { AbstractControl } from '@angular/forms';
import { isValidIBAN } from 'node_modules/ibantools';

export function ibanValidator(control: AbstractControl): { [key: string]: any } {
    const ibanValue = control.value;
    return isValidIBAN(ibanValue) ? null : { iban: true };
}
